import { Badge } from '@/components/ui/badge'
import { type SequenceTemplate } from '@/models/sequenceTemplate'

const LINE = 'text-muted-foreground flex items-center gap-2 text-sm'

/** Who sees this template, so an edit to a shared one isn't a surprise. */
export function SequenceTemplateScopeNote({ template }: { template: SequenceTemplate }) {
  if (template.isGlobal) {
    return (
      <p className={LINE}>
        <Badge variant="secondary">Global</Badge>
        Everyone on the team can use and edit this template.
      </p>
    )
  }
  return (
    <p className={LINE}>
      <Badge variant="outline">Personal</Badge>
      Only you can see and use this template.
    </p>
  )
}
